import React from "react";

const Topbar = ({ className }) => {
  return <div className={`fixed ${className}`}></div>;
};

export default Topbar;
